import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'Components/Button';
import ControllerInput from 'Components/ControllerInput';
import ControllerSelect from 'Components/ControllerSelect';
import Label from 'Components/Label';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ConversacionesService from 'Services/Http/Conversaciones.service';
import { CrearPreguntaSchema } from 'Services/yup/form';

const CrearPreguntaComponent = () => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    getTiposPersona();
  }, []);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      tipo: '',
      pregunta: ''
    },
    resolver: yupResolver(CrearPreguntaSchema)
  });
  const getTiposPersona = async () => {
    try {
      const response = await ConversacionesService.getTiposPersona();
      const options = Object.keys(response.data).map((key) => {
        return {
          value: key,
          label: response.data[key]
        };
      });
      setOptions(options);
    } catch (e) {
      console.log(e);
    }
  };

  const submit = async (data) => {
    try {
      await ConversacionesService.crearPregunta(data);
      reset();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="flex flex-col gap-5 lg:w-1/4">
      <Label text={'Crear pregunta'} />
      <div className="flex flex-col gap-5">
        <ControllerSelect
          label={'Tipo de respuesta'}
          name={'tipo'}
          control={control}
          error={errors?.tipo}
          data={options}
        />
        <ControllerInput
          label={'Pregunta'}
          name={'pregunta'}
          control={control}
          error={errors?.pregunta}
          type="text"
          placeholder="Escribe la pregunta"
        />
      </div>
      <div className="flex justify-end gap-5">
        <Button label={'Guardar'} color={'primary'} onClick={handleSubmit(submit)} />
      </div>
    </div>
  );
};

export default CrearPreguntaComponent;
